import TransferFundsPage from "./TransferFundsPage";

export default TransferFundsPage;
